import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../../index';
import {NotificationService} from '../../../../services/notification.service';
import {actionSmsConfig, getAllSmsConfigs, upsertSmsConfig} from './sms-config.actions';
import {map, switchMap} from 'rxjs/operators';
import {Apollo} from 'apollo-angular';
import {GET_SMS_CONFIG, SAVE_SMS_CONFIG} from './sms-config.graphql';
import {ActionTypeEnum} from '../../../../shared/enums/data.enums';
import {SettingsService} from '../../../../services/settings.service';

@Injectable()
export class SmsConfigEffects {

  get = createEffect(() => this.actions$.pipe(
    ofType(getAllSmsConfigs),
    switchMap(() => {
      return this.apollo.query({
        query: GET_SMS_CONFIG
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000) {
            this.store.dispatch(upsertSmsConfig({smsConfig: result?.data}));
          }
        })
      );
    })
  ), { dispatch: false });

  save = createEffect(() => this.actions$.pipe(
    ofType(actionSmsConfig),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: SAVE_SMS_CONFIG,
        variables: { inputDto: action.smsConfigDto }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000){
            this.notificationService.successMessageAndCloseModals(result?.response?.message);

            this.store.dispatch(upsertSmsConfig({smsConfig: result?.data}));

            if (action.smsConfigDto.actionType === ActionTypeEnum.delete){
              this.settingsService.reloadCurrentRoute(null);
            }

          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private settingsService: SettingsService,
    private apollo: Apollo
  ) {
  }
}
